export enum LS_NAMES {
  READ_HISTORY = 'anzu_forum_read_history',
  USER_NICKNAME_CHANGE = 'anzu_forum_nickname_change',
  USER_BLOG_CHANGE = 'anzu_forum_blog_change',
  USER_BLACKLIST = 'anzu_forum_user_blacklist',
  DEFAULT_POST_LIST_ORDER = 'anzu_forum_default_post_list_order',
  DEFAULT_MY_PROFILE = 'anzu_forum_default_my_profile',
  DEFAULT_OTHER_PROFILE = 'anzu_forum_default_other_profile',
}

export default function useLocalStorageManager() {
  const getItem = (key: LS_NAMES): string | null => {
    return localStorage.getItem(key)
  }

  const setItem = (key: LS_NAMES, value: string) => {
    localStorage.setItem(key, value)
  }

  return {
    getItem,
    setItem,
  }
}
